import { withRouter } from 'react-router';

/**
 * Sets the HTTP response code on the React-router staticContext during server-side rendering.
 */

var HttpResponseCode = function HttpResponseCode(code) {
  return withRouter(function (_, _ref) {
    var router = _ref.router;

    var _ref2 = router || {},
        staticContext = _ref2.staticContext;

    if (typeof staticContext === "object" && staticContext) {
      staticContext.status = code;
    }

    return null;
  });
};
/**
 * Sets the HTTP response code to 404 on the React-router staticContext during server-side rendering.
 */

var HttpNotFound = HttpResponseCode(404);

export { HttpResponseCode, HttpNotFound };
//# sourceMappingURL=browser.js.map
